import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/Billing.module.css";
import { isValidEmail } from "../../../Utils/isValidEmail";

import { UserData } from "../../../Context/DataContext";
import { formatDate } from "../../../Utils/formatDate";

import successIcon from "./styles/img/ok.svg";
import errorIcon from "./styles/img/not_ok.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { PaymentSuccess } from "./PaymentSuccess";
import {
  calculateTaxesv2,
  getCountryISO,
  getDefaultPostalCode,
  getInvoices,
  showpostalCode,
  updateStripeData,
  validTaxTypes,
  validateVATNumber,
} from "../../../Utils/StripeUtils";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { floatMessage } from "../../../Utils/floatMessage";

function Billing({
  history = true,
  onChange = () => {},
  disabled = false,
  errorForm,
  currency = "usd",
  price_amount = "100",
  setTaxes = () => {},
  setCountriesP = () => {},
}) {
  const navigate = useNavigate();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.Billing
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    setContent(websiteCurrentLang.content.User.MyAccount.Billing);
  }, [websiteCurrentLang]);
  const location = useLocation();
  const [billingData, setBillingData] = useState(UserData()?.BillingData);
  const userData = UserData();
  const [error, setError] = useState();

  const [bills, setBills] = useState();
  const [modal, setModal] = useState();
  const [countries, setCountries] = useState();
  const [companyCountries, setCompanyCountries] = useState();
  const [errors, setErrorForm] = useState({
    email: "",
    first_name: "",
    last_name: "",
    country: "",
    address: "",
    type: "",
    vat_company_number: "",
    tax_type: "",
  });
  useEffect(() => {
    console.log("Hemos llegado 1");
    if (!countries) return;
    let country = billingData?.country || "us";
    console.log("Se estña actualizando estooooo");
    // if (!showpostalCode(countries, billingData?.country)) return
    let postal_code =
      billingData?.postal_code ||
      getDefaultPostalCode(countries, country) ||
      "";
    console.log("EXECUTING THE PLANNNN");
    setTaxes(
      calculateTaxesv2(Math.floor(price_amount), countries, country, currency)
    );
    // calculateTaxes(currency, country, Math.floor(price_amount), postal_code, '130')
    // .then(async res=>{
    //     const country_error = {}
    //     if (res.status===200) {
    //         country_error['postal_code']=''
    //         await res.json().then(taxData=>setTaxes(taxData))
    //     }
    //     else if(res.status===409){
    //         country_error['postal_code']='Invalid postal code. For certain location, postal code is needed'

    //     }
    //     else country_error['postal_code']='An error occurred'
    //     setErrorForm({...errors, ...country_error})
    // })
  }, [currency, price_amount]);
  useEffect(() => {
    getCountryISO()
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        //We are sorting th
        data.sort((a, b) => {
          const a_name =
            a?.name[`${websiteCurrentLang?.label}_common`]
              ?.replace("É", "E")
              ?.replace("Î", "I") || a?.name?.common;
          const b_name =
            b?.name[`${websiteCurrentLang?.label}_common`]
              ?.replace("É", "E")
              ?.replace("Î", "I") || b?.name?.common;
          if (a_name > b_name) {
            return 1;
          }
          if (a_name < b_name) {
            return -1;
          }
          return 0;
        });
        setCountries(data);
        setCountriesP(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  useEffect(() => {
    if (!billingData?.type) {
      setBillingData({
        ...billingData,
        address: "",
        type: "Individual",
        vat_company_number: "",
        country: "us",
      });
    }
    if (billingData?.plan === "free" && location.pathname !== "/user/plan") {
      // To cancel the redirections
      return;
      return navigate("/user/plan", {
        replace: true,
        state: { default_years: 3 },
      });
      setModal(
        <PaymentSuccess
          title={content.billingText1}
          subtitle={content.billingText2}
          button={content.billingText3}
          OnClose={() => {
            navigate("/user/plan", { replace: true });
          }}
        />
      );
    }
  }, [billingData?.type]);

  useEffect(() => {
    getInvoices()
      .then((res) => {
        if (res.status !== 200) throw new Error();
        else return res.json();
      })
      .then((res) => {
        setBills(res);
      })
      .catch((e) => {
        setError(content.billingError1);
      });
  }, []);
  useEffect(() => {
    //When a new country is selected, we need to verify the address and the VAT
    //Verify VAT
    if (!countries) return;
    if (!billingData?.country) return;
    let country = billingData?.country || "us";
    //    setBillingData({...billingData, "postal_code":null})
    let postal_code = getDefaultPostalCode(countries, country) || "";
    const vat_number = billingData?.vat_company_number;
    // Promise.all([vat_number?validateVATNumber(billingData?.country, billingData?.vat_company_number):undefined, calculateTaxes(currency, billingData?.country, Math.floor(price_amount), postal_code)])
    Promise.all([
      vat_number
        ? validateVATNumber(
            billingData?.country,
            billingData?.vat_company_number
          )
        : undefined,
    ]).then(async (responses) => {
      console.log("PROMISE ALLLLL");
      const vat_response = responses[0];
      const country_error = {};
      try {
        await vat_response
          ?.json()
          .then((data) => {
            const tax_type = data?.tax_type;
            setBillingData({ ...billingData, tax_type });
            country_error["vat_company_number"] = null;
          })
          .catch((e) => {
            country_error["vat_company_number"] =
              dublicatedcontent?.invalid_number;
          });
      } catch (error) {
        //
      }
      setTaxes(
        calculateTaxesv2(
          Math.floor(price_amount),
          countries,
          billingData?.country,
          currency
        )
      );
      setErrorForm({ ...errors, ...country_error });
    });
  }, [billingData?.country, countries]);
  useEffect(() => {
    // const timerID = setTimeout(()=>{
    // if (!countries) return
    // let country = billingData?.country||'us'
    // console.log('Se estña actualizando estooooo')
    // if (!showpostalCode(countries, billingData?.country)) return
    // let postal_code = billingData?.postal_code||(getDefaultPostalCode(countries, country)||'')
    // calculateTaxes(currency, country, Math.floor(price_amount), postal_code, '130')
    // .then(async res=>{
    //     const country_error = {}
    //     if (res.status===200) {
    //         country_error['postal_code']=''
    //         await res.json().then(taxData=>setTaxes(taxData))
    //     }
    //     else if(res.status===409){
    //         country_error['postal_code']='Invalid postal code. For certain location, postal code is needed'
    //     }
    //     else country_error['postal_code']='An error occurred'
    //     setErrorForm({...errors, ...country_error})
    // })
    // }, 500)
    // return ()=>clearTimeout(timerID)
  }, [billingData?.postal_code]);
  const checkBilling = async () => {
    let newErrors = {};
    // if (showpostalCode(countries, billingData?.country)){
    //     const res = await calculateTaxes(currency, billingData?.country, Math.floor(price_amount), billingData?.postal_code, undefined)
    //     if (res.status!==200) newErrors.postal_code='Invalid postal code'
    // }

    if (billingData.type === "Individual") {
      if (billingData.email === "") {
        newErrors.email = dublicatedcontent.dublicatedText79;
      }
      if (billingData.first_name === "") {
        newErrors.first_name = content.billingError3;
      }
      if (billingData.last_name === "") {
        newErrors.last_name = content.billingError4;
      }

      if (billingData.address === "") {
        newErrors.address = dublicatedcontent.dublicatedText79;
      }

      if (billingData.country === "") {
        newErrors.country = content.billingError5;
      }

      if (billingData.email && !isValidEmail(billingData.email)) {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
    } else if (billingData.type === "Company") {
      if (billingData.email === "") {
        newErrors.email = dublicatedcontent.dublicatedText79;
      }
      if (billingData.first_name === "") {
        newErrors.first_name = content.billingText4;
      }
      if (billingData.vat_company_number === "") {
        newErrors.vat_company_number = content.billingText5;
      }

      if (billingData.address === "") {
        newErrors.address = content.billingText6;
      }

      if (billingData.country === "") {
        newErrors.country = content.billingText7;
      }

      if (billingData.email && !isValidEmail(billingData.email)) {
        newErrors.email = dublicatedcontent.dublicatedText47;
      }
      const res = await validateVATNumber(
        billingData?.country,
        billingData.vat_company_number
      );
      if (res.status !== 200)
        newErrors.vat_company_number = dublicatedcontent?.invalid_number;
    }

    console.log(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setErrorForm(newErrors);
      setTimeout(() => {
        Object.keys(errors).forEach((key) => {
          setErrorForm((prevError) => ({ ...prevError, [key]: null }));
        });
      }, 5000);
      return true;
    }
  };
  //Retrieving TAX TYPES for Companies
  useEffect(() => {
    validTaxTypes()
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // setCompanyCountries([... new Set(data.map(e=>{
        //     const {country_name, country_code} = e
        //     return JSON.stringify(e)
        // }))].map(e=>{
        //     return JSON.parse(e)
        // }))
        data.sort((a, b) => {
          const a_name =
            a[`${websiteCurrentLang?.label}_country_name`]
              ?.replace("É", "E")
              ?.replace("Î", "I") || a?.country_name;
          const b_name =
            b[`${websiteCurrentLang?.label}_country_name`]
              ?.replace("É", "E")
              ?.replace("Î", "I") || b?.country_name;
          if (a_name > b_name) {
            return 1;
          }
          if (a_name < b_name) {
            return -1;
          }
          return 0;
        });
        setCompanyCountries(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  useEffect(() => {
    const country = billingData?.country;
    const vat_number = billingData?.vat_company_number;
    if (!country || !vat_number) return;
    const delayedValidation = setTimeout(() => {
      validateVATNumber(billingData?.country, billingData?.vat_company_number)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const tax_type = data?.tax_type;
          setBillingData({ ...billingData, tax_type });
          setErrorForm({ ...errors, vat_company_number: null });
        })
        .catch((e) => {
          console.log(e);
          setBillingData({ ...billingData, tax_type: null });
          setErrorForm({
            ...errors,
            vat_company_number: dublicatedcontent?.invalid_number,
          });
        });
    }, 1000);
    return () => clearTimeout(delayedValidation);
  }, [billingData?.vat_company_number]);
  useEffect(() => {
    onChange(billingData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [, billingData]);

  return (
    <>
      <div className={styles.main}>
        <div className={styles.left}>
          <div
            className={styles.vertical_line}
            style={{ display: history ? "inline" : "none" }}
          />
          <div className={styles.title}>{content.billingTitle1}</div>
          <div className={styles.rect}></div>
          <div
            onClick={() =>
              setBillingData({ ...billingData, type: "Individual" })
            }
            className={styles.option}
          >
            <div className={styles.circle}>
              {billingData?.type === "Individual" ? (
                <div className={styles.checked}></div>
              ) : null}
            </div>
            <div className={styles.radio_title}>{content.billingText8}</div>
          </div>
          <div
            className={styles.billing_data}
            style={{
              display: billingData?.type === "Individual" ? "flex" : "none",
            }}
          >
            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {dublicatedcontent.dublicatedText42}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({ ...billingData, email: e.target.value });
                  }}
                  value={billingData?.email || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.email || errors?.email ? styles.field_error : ""
                  }`}
                  placeholder={dublicatedcontent.dublicatedText42}
                ></input>
                {errorForm?.email ? (
                  <div className={styles.error_message}>{errorForm.email}</div>
                ) : null}
                {errors?.email ? (
                  <div className={styles.error_message}>{errors.email}</div>
                ) : null}
              </div>
              <div className={styles.input_div}></div>
            </div>
            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText10}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({
                      ...billingData,
                      first_name: e.target.value,
                    });
                  }}
                  value={billingData?.first_name || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.first_name || errors?.first_name
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText10}
                ></input>
                {errorForm?.first_name ? (
                  <div className={styles.error_message}>
                    {errorForm.first_name}
                  </div>
                ) : null}
                {errors?.first_name ? (
                  <div className={styles.error_message}>
                    {errors.first_name}
                  </div>
                ) : null}
              </div>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText11}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({
                      ...billingData,
                      last_name: e.target.value,
                    });
                  }}
                  value={billingData?.last_name || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.last_name || errors?.last_name
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText11}
                ></input>
                {errorForm?.last_name ? (
                  <div className={styles.error_message}>
                    {errorForm.last_name}
                  </div>
                ) : null}
                {errors?.last_name ? (
                  <div className={styles.error_message}>{errors.last_name}</div>
                ) : null}
              </div>
            </div>
            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText12}
                </div>
                <select
                  onChange={(e) => {
                    setBillingData({ ...billingData, country: e.target.value });
                  }}
                  value={billingData?.country?.toUpperCase() || "US"}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.country || errors?.country
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText12}
                >
                  {countries?.map((country, index) => (
                    <option key={index} value={country?.cca2}>
                      {country?.name[`${websiteCurrentLang?.label}_common`] ||
                        country?.name?.common}
                    </option>
                  ))}
                </select>
                {errorForm?.country ? (
                  <div className={styles.error_message}>
                    {errorForm.country}
                  </div>
                ) : null}
                {errors?.country ? (
                  <div className={styles.error_message}>{errors.country}</div>
                ) : null}
              </div>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText14}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({ ...billingData, address: e.target.value });
                  }}
                  value={billingData?.address || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.address || errors?.address
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText14}
                ></input>
                {errorForm?.address ? (
                  <div className={styles.error_message}>
                    {errorForm.address}
                  </div>
                ) : null}
                {errors?.address ? (
                  <div className={styles.error_message}>{errors.address}</div>
                ) : null}
              </div>
              {showpostalCode(countries, billingData?.country) && (
                <div className={styles.input_div}>
                  {/* <div className={styles.input_title}>{getPostalName(countries, billingData?.country)}</div> */}
                  <div className={styles.input_title}>
                    {dublicatedcontent?.postal_code}
                  </div>
                  {/* ||countries.filter(e=>e?.cca2.toLowerCase()==billingData?.country?.toLowerCase())[0]?.postal_code */}
                  <input
                    onChange={(e) => {
                      setBillingData({
                        ...billingData,
                        postal_code: e.target.value,
                      });
                    }}
                    value={billingData?.postal_code || ""}
                    disabled={disabled}
                    className={`${styles.user_input} ${
                      errorForm?.address || errors?.address
                        ? styles.field_error
                        : ""
                    }`}
                    placeholder={dublicatedcontent?.postal_code}
                  ></input>
                  {errorForm?.postal_code ? (
                    <div className={styles.error_message}>
                      {errorForm.postal_code}
                    </div>
                  ) : null}
                  {errors?.postal_code ? (
                    <div className={styles.error_message}>
                      {errors.postal_code}
                    </div>
                  ) : null}
                </div>
              )}
            </div>
            <div className={styles.footer}>
              <div
                onClick={async () => {
                  if (await checkBilling()) {
                    return;
                  }
                  const billingData_ = {
                    ...billingData,
                    postal_code: showpostalCode(countries, billingData?.country)
                      ? billingData?.postal_code
                      : "",
                    vat_company_number: "",
                  };

                  updateStripeData(billingData_)
                    .then((res) => {
                      if (res.status === 200) {
                        userData.setBillingData(billingData_);
                        floatMessage(content.billingText15);
                      }
                    })
                    .catch((e) => {
                      setError(content.billingError7);
                      setTimeout(() => {
                        setError();
                      }, 4000);
                    });
                }}
                style={{ display: history ? "inline-block" : "none" }}
                className={styles.save_button}
              >
                {content.billingText16}
              </div>
            </div>
          </div>
          <div
            onClick={() => setBillingData({ ...billingData, type: "Company" })}
            className={styles.option}
          >
            <div className={styles.circle}>
              {billingData?.type === "Company" ? (
                <div className={styles.checked}></div>
              ) : null}
            </div>
            <div className={styles.radio_title}>
              {dublicatedcontent.dublicatedText37}
            </div>
          </div>
          <div
            className={styles.billing_data}
            style={{
              display: billingData?.type === "Company" ? "flex" : "none",
            }}
          >
            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {dublicatedcontent.dublicatedText42}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({ ...billingData, email: e.target.value });
                  }}
                  value={billingData?.email || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.email || errors?.email ? styles.field_error : ""
                  }`}
                  placeholder={dublicatedcontent.dublicatedText42}
                ></input>
                {errorForm?.email ? (
                  <div className={styles.error_message}>{errorForm.email}</div>
                ) : null}
                {errors?.email ? (
                  <div className={styles.error_message}>{errors.email}</div>
                ) : null}
              </div>
              <div className={styles.input_div}></div>
            </div>

            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText18}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({
                      ...billingData,
                      first_name: e.target.value,
                    });
                  }}
                  value={billingData?.first_name || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.first_name || errors?.first_name
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content?.billingText18}
                ></input>
                {errorForm?.first_name ? (
                  <div className={styles.error_message}>
                    {errorForm.first_name}
                  </div>
                ) : null}
                {errors?.first_name ? (
                  <div className={styles.error_message}>
                    {errors.first_name}
                  </div>
                ) : null}
              </div>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText19}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({
                      ...billingData,
                      vat_company_number: e.target.value,
                    });
                  }}
                  value={billingData?.vat_company_number || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.vat_company_number || errors?.vat_company_number
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={`${content.billingText19}`}
                ></input>
                {errorForm?.vat_company_number ? (
                  <div className={styles.error_message}>
                    {errorForm.vat_company_number}
                  </div>
                ) : null}
                {errors?.vat_company_number ? (
                  <div className={styles.error_message}>
                    {errors.vat_company_number}
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.user_name}>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText13}
                </div>
                <select
                  onChange={(e) => {
                    setBillingData({ ...billingData, country: e.target.value });
                  }}
                  value={billingData?.country?.toLowerCase() || "us"}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.country || errors?.country
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText13}
                >
                  {[
                    ...new Set(
                      companyCountries?.map((e) => {
                        const { tax_code, ...rest } = e;

                        return JSON.stringify(rest);
                      })
                    ),
                  ]?.map((country_, index) => (
                    <option
                      key={index}
                      value={JSON.parse(country_)?.country_code}
                    >
                      {JSON.parse(country_)[
                        `${websiteCurrentLang?.label}_country_name`
                      ] || JSON.parse(country_)?.country_name}
                    </option>
                  ))}
                </select>
                {errorForm?.country ? (
                  <div className={styles.error_message}>
                    {errorForm.country}
                  </div>
                ) : null}
                {errors?.country ? (
                  <div className={styles.error_message}>{errors.country}</div>
                ) : null}
              </div>
              <div className={styles.input_div}>
                <div className={styles.input_title}>
                  {content.billingText20}
                </div>
                <input
                  onChange={(e) => {
                    setBillingData({ ...billingData, address: e.target.value });
                  }}
                  value={billingData?.address || ""}
                  disabled={disabled}
                  className={`${styles.user_input} ${
                    errorForm?.address || errors?.address
                      ? styles.field_error
                      : ""
                  }`}
                  placeholder={content.billingText20}
                ></input>
                {errorForm?.address ? (
                  <div className={styles.error_message}>
                    {errorForm.address}
                  </div>
                ) : null}
                {errors?.address ? (
                  <div className={styles.error_message}>{errors.address}</div>
                ) : null}
              </div>
              {showpostalCode(countries, billingData?.country) && (
                <div className={styles.input_div}>
                  <div className={styles.input_title}>
                    {dublicatedcontent?.postal_code}
                  </div>
                  {/* ||countries.filter(e=>e?.cca2.toLowerCase()==billingData?.country?.toLowerCase())[0]?.postal_code */}
                  <input
                    onChange={(e) => {
                      setBillingData({
                        ...billingData,
                        postal_code: e.target.value,
                      });
                    }}
                    value={billingData?.postal_code || ""}
                    disabled={disabled}
                    className={`${styles.user_input} ${
                      errorForm?.address || errors?.address
                        ? styles.field_error
                        : ""
                    }`}
                    placeholder={dublicatedcontent?.postal_code}
                  ></input>
                  {errorForm?.postal_code ? (
                    <div className={styles.error_message}>
                      {errorForm.postal_code}
                    </div>
                  ) : null}
                  {errors?.postal_code ? (
                    <div className={styles.error_message}>
                      {errors.postal_code}
                    </div>
                  ) : null}
                </div>
              )}
            </div>

            <div className={styles.footer}>
              <div
                onClick={async () => {
                  if (await checkBilling()) {
                    return;
                  }
                  const billingData_ = {
                    ...billingData,
                    postal_code: showpostalCode(countries, billingData?.country)
                      ? billingData?.postal_code
                      : "",
                  };
                  updateStripeData(billingData_)
                    .then((res) => {
                      if (res.status === 200) {
                        // dependiendo de si el postal code es necesario o no
                        userData.setBillingData(billingData_);
                        floatMessage(content.billingText15);
                      }
                    })
                    .catch((e) => {
                      setError(content.billingError7);
                      setTimeout(() => {
                        setError();
                      }, 4000);
                    });
                }}
                style={{ display: history ? "inline-block" : "none" }}
                className={styles.save_button}
              >
                {content.billingText16}
              </div>
            </div>
          </div>

          <div className={styles.error_message}>{error ? error : null}</div>
        </div>

        <div
          className={styles.history}
          style={{ display: history ? "block" : "none" }}
        >
          <div className={styles.radio_title}>{content.billingText21}</div>
          <div className={styles.rect}></div>

          {bills && bills.length ? (
            <div>
              <div className={styles.billing_list}>
                <div className={styles.billing_list_title}>
                  {content.billingText22}
                </div>
                <table className={styles.billing_table}>
                  <tbody>
                    {bills?.map((invoice) => {
                      return (
                        <tr>
                          <td>
                            {formatDate(invoice?.date * 1000).split(" ")[0]}
                          </td>
                          <td>
                            <a
                              href={invoice.invoice_link}
                              target={invoice.invoice_link}
                            >
                              <svg
                                width="634.855"
                                height="800"
                                viewBox="0 0 252.504 318.188"
                                fill="red"
                              >
                                <path d="M250.307 52.722 199.783 2.197A7.5 7.5 0 0 0 194.479 0H7.5A7.5 7.5 0 0 0 0 7.5v303.188a7.5 7.5 0 0 0 7.5 7.5h237.504a7.5 7.5 0 0 0 7.5-7.5V58.025c0-1.989-.79-3.896-2.197-5.303zm-48.328-27.115 24.918 24.919h-24.918ZM15 15h171.98v10.263H15Zm222.504 288.188H15V40.263h171.98v17.763a7.5 7.5 0 0 0 7.5 7.5h43.024z" />
                                <path d="M168.862 147.048c-3.615-.024-7.177.154-10.693.354-1.296.087-2.579.199-3.861.31a93.594 93.594 0 0 1-3.813-4.202c-7.82-9.257-14.134-19.755-19.279-30.664 1.366-5.271 2.459-10.772 3.119-16.485 1.205-10.427 1.619-22.31-2.288-32.251-1.349-3.431-4.946-7.608-9.096-5.528-4.771 2.392-6.113 9.169-6.502 13.973-.313 3.883-.094 7.776.558 11.594.664 3.844 1.733 7.494 2.897 11.139a165.324 165.324 0 0 0 3.588 9.943 171.593 171.593 0 0 1-2.63 7.603c-2.152 5.643-4.479 11.004-6.717 16.161l-3.465 7.507c-3.576 7.855-7.458 15.566-11.814 23.02-10.163 3.585-19.283 7.741-26.857 12.625-4.063 2.625-7.652 5.476-10.641 8.603-2.822 2.952-5.69 6.783-5.941 11.024-.141 2.394.807 4.717 2.768 6.137 2.697 2.015 6.271 1.881 9.4 1.225 10.25-2.15 18.121-10.961 24.824-18.387 4.617-5.115 9.872-11.61 15.369-19.465l.037-.054c9.428-2.923 19.689-5.391 30.579-7.205 4.975-.825 10.082-1.5 15.291-1.974 3.663 3.431 7.621 6.555 11.939 9.164 3.363 2.069 6.94 3.816 10.684 5.119 3.786 1.237 7.595 2.247 11.528 2.886 1.986.284 4.017.413 6.092.335 4.631-.175 11.278-1.951 11.714-7.57.134-1.721-.237-3.229-.98-4.551-3.643-6.493-16.231-8.533-22.006-9.451-4.553-.723-9.2-.939-13.804-.935zm-75.06 20.697a170.827 170.827 0 0 1-6.232 9.041c-4.827 6.568-10.34 14.369-18.322 17.286-1.516.554-3.512 1.126-5.616 1.002-1.874-.11-3.722-.936-3.637-3.065.042-1.114.587-2.535 1.423-3.931.915-1.531 2.048-2.935 3.275-4.226 2.629-2.762 5.953-5.439 9.777-7.918 5.865-3.805 12.867-7.23 20.672-10.286-.449.71-.897 1.416-1.34 2.097zm27.222-84.26a38.169 38.169 0 0 1-.323-10.503 24.858 24.858 0 0 1 1.038-4.952c.428-1.33 1.352-4.576 2.826-4.993 2.43-.688 3.177 4.529 3.452 6.005 1.566 8.396.186 17.733-1.693 25.969-.299 1.31-.632 2.599-.973 3.883a121.219 121.219 0 0 1-1.648-4.821c-1.1-3.525-2.106-7.091-2.679-10.588zm16.683 66.28a236.508 236.508 0 0 0-25.979 5.708c.983-.275 5.475-8.788 6.477-10.555 4.721-8.315 8.583-17.042 11.358-26.197 4.9 9.691 10.847 18.962 18.153 27.214.673.749 1.357 1.489 2.053 2.22-4.094.441-8.123.978-12.062 1.61zm61.744 11.694c-.334 1.805-4.189 2.837-5.988 3.121-5.316.836-10.94.167-16.028-1.542-3.491-1.172-6.858-2.768-10.057-4.688-3.18-1.921-6.155-4.181-8.936-6.673 3.429-.206 6.9-.341 10.388-.275 3.488.035 7.003.211 10.475.664 6.511.726 13.807 2.961 18.932 7.186 1.009.833 1.331 1.569 1.214 2.207z" />
                              </svg>
                              {dublicatedcontent?.invoice} #
                              {invoice.invoice_number}
                            </a>
                          </td>
                          <td>
                            {dublicatedcontent?.price_format
                              ?.replace("currency_", invoice?.currency_symbol)
                              ?.replace("amount_", invoice.price / 100)}
                            {/* {
                                                    (invoice?.currency_symbol!=='€'&&invoice?.currency_symbol!=='CHF')?
                                                    `${invoice?.currency_symbol} ${invoice.price / 100}`
                                                    :`${invoice?.currency_symbol} ${invoice.price / 100}`
                                                    } */}
                          </td>
                          <td>
                            {invoice.status === "succeeded" && (
                              <span className={styles.status}>
                                <img
                                  src={successIcon}
                                  className={styles.status_icon}
                                  alt=""
                                />
                                {content?.billingText23}
                              </span>
                            )}
                            {invoice.status === "pending" && (
                              <span className={styles.status}>
                                <img
                                  src={errorIcon}
                                  className={styles.status_icon}
                                  alt=""
                                />
                                {content?.billingText27}
                              </span>
                            )}
                            {!["pending", "succeeded"].includes(
                              invoice.status
                            ) && (
                              <span className={styles.status}>
                                <img
                                  src={errorIcon}
                                  className={styles.status_icon}
                                  alt=""
                                />
                                {content?.billingText24}
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className={styles.billing_list}>
                <div className={styles.billing_list_title}>
                  {content.billingText25}
                </div>
                <table className={styles.billing_table}>
                  <tbody>
                    {bills?.map((invoice) => {
                      return (
                        <tr>
                          <td>
                            {formatDate(invoice?.date * 1000).split(" ")[0]}
                          </td>
                          <td>
                            {dublicatedcontent[
                              invoice?.reason?.replace(" ", "_")?.toLowerCase()
                            ] || invoice.reason}
                          </td>
                          <td>{invoice.transaction_id}</td>
                          <td>
                            {dublicatedcontent?.price_format
                              ?.replace("currency_", invoice?.currency_symbol)
                              ?.replace("amount_", invoice.price / 100)}

                            {/* {
                                                    (invoice?.currency_symbol!=='€'&&invoice?.currency_symbol!=='CHF')?
                                                    `${invoice?.currency_symbol} ${invoice.price / 100}`
                                                    :`${invoice?.currency_symbol} ${invoice.price / 100}`
                                                    } */}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className={styles.hint}>{content?.billingText26}</div>
        </div>
        {modal}
      </div>
    </>
  );
}
export { Billing };
